import { withActionDialogLock } from "@/action-dialog/actionDialogLock";
import {
  RenameCanvasCallable,
  RenameChatCallable,
  RenameFileRecordCallable,
} from "@/action-dialog/callables/RenameMoveCallables";
import type { Canvas, FileRecord, InboxItem } from "@cohesive/api-client";

export interface RenameCanvasParams {
  canvas: Canvas;
  detailsLoading?: boolean;
  onRenamed?: (name: string) => void;
}

export function runRenameCanvasWorkflow(
  params: RenameCanvasParams,
): Promise<boolean> {
  return withActionDialogLock(() =>
    RenameCanvasCallable.call({
      canvas: params.canvas,
      detailsLoading: params.detailsLoading,
      onRenamed: params.onRenamed,
    }),
  );
}

export interface RenameChatParams {
  item: InboxItem;
  onRenamed?: (name: string) => void;
}

export function runRenameChatWorkflow(
  params: RenameChatParams,
): Promise<boolean> {
  return withActionDialogLock(() =>
    RenameChatCallable.call({
      item: params.item,
      onRenamed: params.onRenamed,
    }),
  );
}

export interface RenameFileRecordParams {
  record: FileRecord;
  allRecords: FileRecord[];
}

export function runRenameFileRecordWorkflow(
  params: RenameFileRecordParams,
): Promise<boolean> {
  return withActionDialogLock(() =>
    RenameFileRecordCallable.call({
      record: params.record,
      allRecords: params.allRecords,
    }),
  );
}
